import { field, scope, vector, KeyIndexImpl } from '../instructions';
import { BuddhistEraIndex, DateTimePatternFieldValues, DayPeriodValues, EraWidthValues, FieldWidthValues, FormatWidthValues, GregorianEraIndex, GregorianMonthsIndex, JapaneseEraIndex, PersianEraIndex, QuarterValues, WeekdayValues, } from '../schema';
var formats = function (name, rename, month) {
    return scope(name, rename, [
        vector('weekdays', ['field-width', 'weekday']),
        vector('months', ['field-width', month + "-month"]),
        vector('quarters', ['field-width', 'quarter']),
        vector('dayPeriods', ['field-width', 'day-period', 'day-period-alt-key']),
    ]);
};
var calendarScope = function (name, scopeName) {
    return scope(scopeName, scopeName, [
        vector('eras', ['era-type', name + "-era", 'era-alt-key']),
        formats('format', 'format', name),
        formats('standAlone', 'standAlone', name),
        vector('availableFormats', [name + "-available-format"]),
        vector('pluralFormats', ['plural-key', name + "-plural-format"]),
        vector('intervalFormats', ['date-time-pattern-field', name + "-interval-format"]),
        vector('dateFormats', ['format-width']),
        vector('timeFormats', ['format-width']),
        vector('dateTimeFormats', ['format-width']),
        field('intervalFormatFallback'),
    ]);
};
export var DateTimePatternFieldIndex = new KeyIndexImpl(DateTimePatternFieldValues);
export var DayPeriodIndex = new KeyIndexImpl(DayPeriodValues);
export var EraTypeIndex = new KeyIndexImpl(EraWidthValues);
export var FieldWidthIndex = new KeyIndexImpl(FieldWidthValues);
export var FormatWidthIndex = new KeyIndexImpl(FormatWidthValues);
export var QuartersIndex = new KeyIndexImpl(QuarterValues);
export var WeekdaysIndex = new KeyIndexImpl(WeekdayValues);
export var CALENDAR_INDICES = {
    'date-time-pattern-field': DateTimePatternFieldIndex,
    'day-period': DayPeriodIndex,
    'era-type': EraTypeIndex,
    'field-width': FieldWidthIndex,
    'format-width': FormatWidthIndex,
    quarter: QuartersIndex,
    weekday: WeekdaysIndex,
};
export var BUDDHIST = calendarScope('buddhist', 'Buddhist');
export var BUDDHIST_INDICES = {
    'buddhist-era': BuddhistEraIndex,
    'buddhist-month': GregorianMonthsIndex,
};
export var GREGORIAN = calendarScope('gregorian', 'Gregorian');
export var GREGORIAN_INDICES = {
    'gregorian-era': GregorianEraIndex,
    'gregorian-month': GregorianMonthsIndex,
};
export var JAPANESE = calendarScope('japanese', 'Japanese');
export var JAPANESE_INDICES = {
    'japanese-era': JapaneseEraIndex,
    'japanese-month': GregorianMonthsIndex,
};
export var PERSIAN = calendarScope('persian', 'Persian');
export var PERSIAN_INDICES = {
    'persian-era': PersianEraIndex,
    'persian-month': GregorianMonthsIndex,
};
//# sourceMappingURL=calendars.js.map